import { jsx as t } from "react/jsx-runtime";
import { useRef as T } from "react";
import e from "./index.es768.js";
import d from "classnames";
import * as G from "@radix-ui/react-toggle-group";
import { ToggleButtonItem as h } from "./index.es769.js";
import { LabeledField as B } from "./index.es512.js";
const E = "toggle-button-component", y = ({
  size: p = "default",
  label: n,
  isFixedWidth: a = !1,
  items: m,
  value: r,
  onChange: i,
  testId: s = E,
  disabled: l,
  fullWidth: f
}) => {
  const g = T(null), u = d({
    [e.containerFlex]: !a,
    [e.containerGrid]: a,
    [e.fullWidth]: f
  }), c = (o) => {
    o && o !== r && i(o);
  };
  return /* @__PURE__ */ t(B, { label: n, testId: `${s}-wrapper`, children: /* @__PURE__ */ t(
    G.Root,
    {
      ref: g,
      className: u,
      type: "single",
      value: r,
      "aria-label": n ?? "Radio Group",
      onValueChange: c,
      "data-testid": s,
      disabled: l,
      role: "radiogroup",
      children: m.map((o) => /* @__PURE__ */ t(
        h,
        {
          size: p,
          item: o,
          disabled: l,
          isActive: o.value === r
        },
        o.value
      ))
    }
  ) });
};
export {
  E as TOGGLE_BUTTON_DEFAULT_TESTID,
  y as ToggleButton
};
//# sourceMappingURL=index.es8.js.map
